export default "__VITE_ASSET__4099e389__"